const syncJobResponseToSyncJobObject = (response) => {
    return {
        id: response.id,
        platformEntityType: response.platform_entity_type,
        userId: response.user_id,
        createdAt: response.created_at,
        startedAt: response.started_at,
        finishedAt: response.finished_at,
        itemsSynced: response.items_synced,
        status: response.status,
        params: response.params,
    };
};

export { syncJobResponseToSyncJobObject };
